module.exports = __webpack_public_path__ + "img/drop2.1e1028b0.png";